import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import TrustBar from "@/components/sections/TrustBar";
import About from "@/components/sections/About";
import CashFramework from "@/components/sections/CashFramework";
import CaseStudies from "@/components/sections/CaseStudies";
import Testimonials from "@/components/sections/Testimonials";
import RealConversations from "@/components/sections/RealConversations";
import Team from "@/components/sections/Team";
import HowItWorks from "@/components/sections/HowItWorks";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import ServicesRecap from "@/components/sections/ServicesRecap";
import TrustBadges from "@/components/sections/TrustBadges";
import PromiseSection from "@/components/sections/Promise";
import Faq from "@/components/sections/Faq";
import TrialBooking from "@/components/sections/TrialBooking";
import Footer from "@/components/sections/Footer";

export default function Home() {
    const [site, setSite] = useState(null);
    const [cases, setCases] = useState([]);
    const [testimonials, setTestimonials] = useState([]);
    const [team, setTeam] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const [s, cs, t, tm] = await Promise.all([
                    api.get("/site-content"),
                    api.get("/case-studies"),
                    api.get("/testimonials"),
                    api.get("/team"),
                ]);
                setSite(s.data);
                setCases(cs.data || []);
                setTestimonials(t.data || []);
                setTeam(tm.data || []);
            } catch (err) {
                console.error("Home data load error:", err);
            }
        })();
    }, []);

    return (
        <div className="min-h-screen text-[var(--text-primary)]">
            <Navbar />
            <main>
                <div data-lit-zone>
                    <Hero site={site} />
                    <div data-lit-target>
                        <TrustBar />
                    </div>
                    <div data-lit-target>
                        <About site={site} />
                    </div>
                </div>
                <CashFramework />
                <HowItWorks />
                <WhyChooseUs />
                <CaseStudies items={cases} />
                <Testimonials items={testimonials} />
                <RealConversations />
                <Team members={team} />
                <ServicesRecap />
                <TrustBadges site={site} />
                <PromiseSection />
                <Faq />
                <TrialBooking />
            </main>
            <Footer site={site} />
        </div>
    );
}
